// extracted by mini-css-extract-plugin
export default {"root":"Stripe_root__Z15Tw"};